<mat-card>
    <mat-card-header style="margin-bottom: 20px">
        <mat-card-title>Patrimônios</mat-card-title>
        <button
            mat-mini-fab
            style=" margin-left: 10px"
            matTooltip="ADICIONAR RECEITA"
            (click)="openCadastro()">
            <mat-icon>add_circle</mat-icon>
        </button>
    </mat-card-header>
    <mat-card-content>
        <mat-card-subtitle>Financeiros</mat-card-subtitle>
        <ngx-datatable 
            #table 
            class='material striped' 
            [loadingIndicator]="loadingIndicator"
            [columns]="columns" 
            [columnMode]="'force'" 
            [headerHeight]="50"
            [footerHeight]="50" 
            [rowHeight]="'auto'"
            [rows]='rows_financial'
        >
            <ngx-datatable-column
                name="Usuario" 
                matTooltip='Usuario' 
                prop="usuario">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{row.usuario?.name || 'Usuário não registrado' }}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
                name="Tipo" 
                matTooltip='Tipo' 
                prop="tipo_patrimonio_id">

                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{row.tipo_patrimonio.descricao}}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column 
                name="Descrição" 
                matTooltip='Descrição' 
                prop="descricao">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{row.descricao}}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
                name="Valor" 
                matTooltip='Valor' 
                prop="valor">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{ row.valor | currency:'BRL':'symbol':'1.2-2' }}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
                name="Inst. Financeira" 
                matTooltip='Instituicao Financeira' 
                prop="instituicao_financeira">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{ row.instituicao_financeira }}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column 
                name="Vencimento" 
                matTooltip='Vencimento' 
                prop="vencimento">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{ row.vencimento ? (row.vencimento | date:'yyyy/MM') : '-' }}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
                name="Open Finance" 
                matTooltip='Open Finance' 
                prop="open_finance">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{ row.open_finance? 'Sim' : 'Não' }}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column 
                name="Finalidade" 
                matTooltip='Finalidade' 
                prop="finalidade">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{row.finalidade}}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column 
                name="Data Atualização" 
                matTooltip='Data da Última Atualização' 
                prop="updated_at">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{ row.updated_at ? (row.updated_at | date:'yyyy/MM/dd') : '-' }}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Ação" prop="id" [sortable]="false">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <button mat-icon-button matTooltip="Altera Item" (click)="openAlterar(row.id)">
                        <mat-icon aria-label="Editar">edit</mat-icon>
                    </button>

                    <button mat-icon-button color="warn" matTooltip="Excluir Item." (click)="delete(row.id)">
                        <mat-icon aria-label="Excluir Item">delete</mat-icon>
                    </button>
                </ng-template>
            </ngx-datatable-column>
        </ngx-datatable>

        <div style="padding: 5px 10px">
            <mat-paginator 
                #paginator 
                [length]="length"
                [pageSize]="pageSize"
                [pageSizeOptions]="pageSizeOptions"
                (page)="pageEvent($event)">
            </mat-paginator>
        </div>
    </mat-card-content>
    <mat-card-content>
        <mat-card-subtitle>Não Financeiros</mat-card-subtitle>
        <ngx-datatable 
            #table 
            class='material striped' 
            [loadingIndicator]="loadingIndicator"
            [columns]="columns" 
            [columnMode]="'force'" 
            [headerHeight]="50"
            [footerHeight]="50" 
            [rowHeight]="'auto'"
            [rows]='rows_not_financial'
        >
            <ngx-datatable-column
                name="Usuario" 
                matTooltip='Usuario' 
                prop="usuario">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{row.usuario?.name || 'Usuário não registrado' }}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column
                name="Tipo" 
                matTooltip='Tipo' 
                prop="tipo_patrimonio_id">

                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{row.tipo_patrimonio.descricao}}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column 
                name="Descrição" 
                matTooltip='Descrição' 
                prop="descricao">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{row.descricao}}
                </ng-template>
            </ngx-datatable-column>
            <!-- <ngx-datatable-column
                name="Financeiro" 
                matTooltip='Financeiro' 
                prop="is_financeiro">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{ row.is_financeiro? 'Sim' : 'Não' }}
                </ng-template>
            </ngx-datatable-column> -->
            <ngx-datatable-column
                name="Valor" 
                matTooltip='Valor' 
                prop="valor">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{ row.valor | currency:'BRL':'symbol':'1.2-2' }}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
                name="Saldo Devedor" 
                matTooltip='Saldo Devedor' 
                prop="saldo_devedor">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{ row.saldo_devedor | currency:'BRL':'symbol':'1.2-2' }}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column 
                name="Finalidade" 
                matTooltip='Finalidade' 
                prop="finalidade">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{row.finalidade}}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column 
                name="Data Atualização" 
                matTooltip='Data da Última Atualização' 
                prop="updated_at">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{ row.updated_at ? (row.updated_at | date:'yyyy/MM/dd') : '-' }}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Ação" prop="id" [sortable]="false">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <button mat-icon-button matTooltip="Altera Item" (click)="openAlterar(row.id)">
                        <mat-icon aria-label="Editar">edit</mat-icon>
                    </button>

                    <button mat-icon-button color="warn" matTooltip="Excluir Item." (click)="delete(row.id)">
                        <mat-icon aria-label="Excluir Item">delete</mat-icon>
                    </button>
                </ng-template>
            </ngx-datatable-column>
        </ngx-datatable>

        <div style="padding: 5px 10px">
            <mat-paginator 
                #paginator 
                [length]="length"
                [pageSize]="pageSize"
                [pageSizeOptions]="pageSizeOptions"
                (page)="pageEvent($event)">
            </mat-paginator>
        </div>
    </mat-card-content>
</mat-card>